import { take, takeLatest, put, fork, cancel } from 'redux-saga/effects'
import { SET_AUTHENTICATED, UNSET_AUTHENTICATED } from '../login/constants'
import { unsetUser, setUser, logout } from '../actions'
import { axios } from '../../apiService'
import { GET_USER } from './constants'
import { store } from 'store'
import { localStorageService } from '../../helpers'
// import axios from 'axios'
import {
  ROLE_ADMIN,
  // ROLE_BUYER_ADMIN USE WAIT API BUYER combined admin_buyer like auth/admin_buyer + auth/buyer to new api name
  ROLE_BUYER_ADMIN,
  ROLE_BUYER,
  ROLE_SUPPLIER,
} from 'store/role/constants'

function* callUserService() {
  // const userEmail = localStorage.getItem('email')
  // const { role } = store.getState()
  // let apiPath = ''
  // switch (role) {
  //   case ROLE_BUYER_ADMIN:
  //     apiPath = 'auth/admin_buyer'
  //     break
  //   case ROLE_BUYER:
  //     apiPath = 'auth/buyer'
  //     break
  //   case ROLE_SUPPLIER:
  //     apiPath = 'auth/supplier'
  //     break
  //   case ROLE_ADMIN:
  //     apiPath = 'auth/admin'
  //     break
  // }
  // const user = yield axios
  //   .get(`${apiPath}/user/${userEmail}`)
  //   .then(res => {
  //     if (res.status === 200) {
  //       return res.data.result
  //     }
  //   })
  //   .catch(error => {
  //     if (error) {
  //       store.dispatch(logout())
  //     }
  //   })
  // yield put(setUser(user))
}

// function* fetchUser() {
//   const task = yield fork(callUserService)
//   yield take(UNSET_AUTHENTICATED)
//   yield cancel(task)
//   yield put(unsetUser())
//   // yield takeLatest(GET_USER, fetchUser)
// }

function* userWatcher() {
  // yield takeLatest(SET_AUTHENTICATED, fetchUser)
  // yield takeLatest(GET_USER, fetchUser)
}
export default userWatcher
